import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/csae')({
  component: CSAEPolicy,
});

function CSAEPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">
        Standards Against Child Sexual Abuse and Exploitation (CSAE)
      </h1>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
        <p className="mb-4">
          GreetAI is committed to maintaining a safe and secure platform that
          protects children from exploitation, abuse, and harm. We strictly
          prohibit any form of Child Sexual Abuse and Exploitation (CSAE) and
          take all necessary steps to prevent, detect, and report such content
          and activity on our platform.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          2. Zero-Tolerance Policy on Child Sexual Abuse Material (CSAM)
        </h2>
        <p className="mb-4">
          GreetAI enforces a zero-tolerance policy against Child Sexual Abuse
          Material (CSAM). This includes but is not limited to:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>
            Any content that depicts, encourages, or facilitates child sexual
            abuse or exploitation.
          </li>
          <li>
            Any attempt to groom, solicit, or engage minors in inappropriate
            conversations or activities.
          </li>
          <li>The sharing, storage, or transmission of CSAM in any form.</li>
          <li>
            The use of the platform for the recruitment or facilitation of child
            trafficking or exploitation.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          3. Proactive Detection and Reporting
        </h2>
        <p className="mb-4">
          To ensure compliance and prevent CSAE, GreetAI implements the
          following measures:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>
            <strong>Automated Scanning & Moderation:</strong> We use AI-driven
            and manual review processes to detect and remove any content that
            violates child safety policies.
          </li>
          <li>
            <strong>User Reporting Mechanisms:</strong> Users can report any
            suspected CSAE content directly within the app, which will be
            reviewed and actioned promptly.
          </li>
          <li>
            <strong>Collaboration with Law Enforcement:</strong> We cooperate
            with global law enforcement agencies and organizations like the
            National Center for Missing and Exploited Children (NCMEC) to report
            and act on any CSAM-related incidents.
          </li>
          <li>
            <strong>Strict Content Moderation:</strong> All user-generated
            content (UGC) is subject to review by our trust and safety team to
            identify and remove any harmful material.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          4. Compliance with Child Safety Laws
        </h2>
        <p className="mb-4">
          GreetAI adheres to all relevant local and international child
          protection laws, including:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Canada's proposed Online Harms Act (Bill C-63)</li>
          <li>
            Canada's proposed Protecting Young Persons from Exposure to
            Pornography Act (Bill S-210)
          </li>
          <li>The U.S. Children's Online Privacy Protection Act (COPPA)</li>
          <li>The U.K. Online Safety Act</li>
          <li>The EU General Data Protection Regulation (GDPR) for children</li>
          <li>
            Other applicable laws that mandate the protection of children online
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          5. User Guidelines & Enforcement
        </h2>
        <ul className="list-disc pl-6 mb-4">
          <li>
            <strong>Age Restrictions:</strong> GreetAI is not intended for users
            under the age of 13. Users found to be underage will have their
            accounts suspended.
          </li>
          <li>
            <strong>Strict Community Standards:</strong> Any content involving
            minors must comply with our safety policies and will be subject to
            moderation.
          </li>
          <li>
            <strong>Account Suspension & Reporting:</strong> Users engaging in
            CSAE-related activities will be permanently banned and reported to
            authorities.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          6. Dedicated Child Safety Contact
        </h2>
        <p className="mb-4">
          For any child safety concerns, authorities, parents, or users can
          contact our dedicated Child Safety Team at{' '}
          <a
            href="mailto:shelia@greetai.co"
            className="text-blue-600 hover:underline">
            shelia@greetai.co
          </a>
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          7. Ongoing Commitment to Safety
        </h2>
        <p className="mb-4">
          GreetAI continuously updates and strengthens its child protection
          measures in alignment with best practices and regulatory requirements.
          We work with child safety experts and advocacy groups to improve our
          policies and detection mechanisms.
        </p>
      </section>

      <footer className="text-sm text-gray-600">
        <p>Last Updated: February 12, 2025</p>
        <p>© GreetAI 2025. All rights reserved.</p>
      </footer>
    </div>
  );
}
